<template>
  <div>
    <confirm-email-signup v-if="isPending" :email="email"></confirm-email-signup>
    <div class="login-container" v-else>
      <div class="row p-sm bg-color-login">
        <div class="col-md-12">
          <div class="text-center">
            <h4>サービス登録</h4>
          </div>
          <div class="alert alert-danger" v-if="err">
            <span id="message" v-html="err"></span>
          </div>
          <div class="hpanel">
            <div class="panel-body">
              <div class="form-group">
                <label class="control-label label-normal" for="sellerName">お名前</label>
                <input type="text" name="sellerName" id="sellerName" class="form-control" v-model="sellerName" v-validate="'required|max:45'" data-vv-as="お名前">
                <span style="display: block" v-show="errors.has('sellerName')" class="text-danger">※{{ errors.first('sellerName') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label label-normal" for="email">メールアドレス</label>
                <input type="text" name="email" id="email" class="form-control" v-model="email" v-validate="'required|email|max:150'" data-vv-as="メールアドレス">
                <span style="display: block" v-show="errors.has('email')" class="text-danger">※{{ errors.first('email') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label label-normal" for="sellerTel">電話番号</label>
                <input type="text" name="sellerTel" id="sellerTel" class="form-control" v-model="sellerTel" v-validate="'required|max:15'" data-vv-as="電話番号">
                <span style="display: block" v-show="errors.has('sellerTel')" class="text-danger">※{{ errors.first('sellerTel') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label label-normal" for="sellerCountry">国</label>
                <select name= "sellerCountry" v-model="selectedCountry" class="form-control" v-on:change="fetchArea" v-validate="'required'" data-vv-as="国">
                  <option
                    v-for="country in countyList"
                    :value="country.country_code"
                    :key="country.country_code"
                  >
                    {{ country.country_name }}
                  </option>
                </select>
                <span style="display: block" v-show="errors.has('sellerCountry')" class="text-danger">※{{ errors.first('sellerCountry') }}</span>
              </div>
              <div class="form-group">
                <label class="control-label label-normal" for="sellerState">地域</label>
                <select name= "sellerState" v-model="selectedState" class="form-control" v-validate="'required'" data-vv-as="地域">
                  <option
                    v-for="state in stateList"
                    :value="state.id"
                    :key="state.id"
                  >
                    {{ state.state_name }}
                  </option>
                </select>
                <span style="display: block" v-show="errors.has('sellerState')" class="text-danger">※{{ errors.first('sellerState') }}</span>
              </div>
              <div class="form-group">
                <img src="https://image-yoshino.sakura.ne.jp/monster/Premium/suddenlyImage01.png" class="full-width">
              </div>
              <button id="signup" class="btn btn-warning btn-block" type="submit" @click="doSignup">登録する</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AreaService from '@/services/areaservice'
import AuthenticationService from '@/services/authenticationservice'
import ConfirmEmailSignup from '@/view/signup/ConfirmEmailSignup'
import msg from '@/common/msg'
import * as code from '@/common/code'
import store from '@/store'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ConfirmEmailSignup
  },
  data () {
    return {
      email: null,
      sellerName: null,
      sellerTel: null,
      affiliater: null,
      err: null,
      isPending: false,
      showModal: false,
      modalMessage: null,
      selectedCountry: null,
      countyList: [],
      selectedState: null,
      stateDefaultList: [],
      stateAllList: [],
      stateList: []
    }
  },
  created () {
    this.getAllArea()
  },
  mounted () {
    if (!this.isPending) {
      let affiliateId = ''
      if (this.$route.query.SellerId) {
        affiliateId = this.$route.query.SellerId
        this.affiliater = affiliateId.slice(0, 10)
      }
      if (this.$route.query.sellerId) {
        affiliateId = this.$route.query.sellerId
        this.affiliater = affiliateId.slice(0, 10)
      }
      let logParams = {
        name: eventCode.show_screen_register,
        properties: {
          affiliater: this.affiliater
        }
      }
      EventService.postTrackLog(logParams)
    }
  },
  methods: {
    async doSignup () {
      const self = this
      let affiliateId = ''
      if (this.$route.query.SellerId) {
        affiliateId = this.$route.query.SellerId
        self.affiliater = affiliateId.slice(0, 10)
      }
      if (this.$route.query.sellerId) {
        affiliateId = this.$route.query.sellerId
        self.affiliater = affiliateId.slice(0, 10)
      }
      let logParams = {
        name: eventCode.click_register_button,
        properties: {
          affiliater: self.affiliater,
          country: self.selectedCountry,
          email: self.email,
          sellerName: self.sellerName,
          sellerTel: self.sellerTel,
          state: self.selectedState
        }
      }
      EventService.postTrackLog(logParams)

      let validated = await self.$validator.validateAll()
      if (validated) {
        const loader = self.$loading.show()
        AuthenticationService.register(self.sellerName, self.email, self.sellerTel, self.affiliater, self.selectedCountry, self.selectedState)
          .then(response => {
            if ((response.resultCode === code.registeredEmail) || (response.resultCode === code.exceptCountry)) {
              store.commit('saveResultCode', response.resultCode)
              this.$router.push('/login')
            } else {
              this.isPending = true
            }
          })
          .catch(error => {
            if (error !== msg.serverErr && typeof error !== 'object') {
              self.err = error
            }
          })
          .finally(() => {
            loader.hide()
          })
      }
    },
    getAllArea () {
      AreaService.getAll()
        .then((response) => {
          var self = this
          response.data.forEach(function (val) {
            self.countyList.push({ country_code: val.country_code, country_name: val.country_name })
            if (val.country_code === 'jp') {
              self.stateList = val.states
            }
            self.stateAllList.push({ country_code: val.country_code, states: val.states })
          })
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    fetchArea () {
      const targetList = this.stateAllList.filter(data => data.country_code === this.selectedCountry)[0]
      this.selectedState = null
      this.stateList = targetList.states
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/signup/Signup.vue